import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '@views/IndexView.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: IndexView
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
